import {
  PAYMENT_STATUS_REQUEST,
  PAYMENT_STATUS_SUCCESS,
  PAYMENT_STATUS_FAILURE
} from './payment-status-types';

const initialState = {
  submitting: false,
  success: false,
  error: null,
  response: null
};

export default function paymentStatusReducer(state = initialState, action) {
  switch (action.type) {
    case PAYMENT_STATUS_REQUEST:
      return {
        ...state,
        submitting: true,
        error: null,
        success: false
      };
    case PAYMENT_STATUS_SUCCESS:
      return {
        ...state,
        submitting: false,
        success: true,
        response: action.payload
      };
    case PAYMENT_STATUS_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload,
        success: false
      };
    default:
      return state;
  }
}
